// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c928f143","769":"3abcb936"}[chunkId] + ".chunk.js";
};